export default "__VITE_ASSET__BkNrvik___"